import Component from '@glimmer/component';
import { action } from '@ember/object';
import { later } from '@ember/runloop';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { StickyController } from 'mewe/utils/elements-utils';
import { addObserver, removeObserver } from '@ember/object/observers';
import { getConfigCatFlagPromise } from 'mewe/shared/config-cat';

export default class AppQuests extends Component {
  @service account;
  @service router;

  @tracked questState = this.args.model.app.questState;
  @tracked isLevelsBoxExpanded = false;
  @tracked isBadgesBoxExpanded = false;
  @tracked showContent = false;

  constructor() {
    super(...arguments);

    // promise used instead of features service to wait until the flag is loaded
    getConfigCatFlagPromise('web_is_gamification_enabled').then((value) => {
      if (!value) {
        this.router.transitionTo('app.myworld');
      }
    });

    addObserver(this, 'questState.isFetching', this.checkEligibility);
    this.checkEligibility();
  }

  willDestroy() {
    removeObserver(this, 'questState.isFetching', this.checkEligibility);
  }

  get displayedLevel() {
    if (this.questState.isFinished) {
      return this.questState.levels[this.questState.levels.length - 1];
    } else {
      return this.questState.currentLevel;
    }
  }

  checkEligibility() {
    if (!this.questState.isFetching && !this.questState.isLoaded) {
      this.router.transitionTo('app.myworld');
    }

    if (this.questState.isLoaded) {
      // preload image to avoid layout shift
      const coverImage = this.displayedLevel.levelImage;
      const img = new Image();
      img.src = coverImage;

      img.onload = () => {
        later(() => {
          this.showContent = true;
        }, 600);
      };
    }
  }

  @action
  onInsertSidebar(element) {
    this.stickyController = new StickyController({ element: element });
  }

}
